/** 後端登入成功回傳。 */
export interface LoginResponseInterface {
  token: string
}

/** 後端 admin profile（GET /admin/account/profile）。 */
export interface AdminProfileInterface {
  id: string
  email: string
  name: string | null
  avatar: string | null
  /**
   * DB 實存的角色 —— 管理員在 /admin 頁勾選的原始值。
   * 不要拿它做權限判斷：super admin / maintainer 的特權捷徑不在這個欄位裡。
   */
  roles: string[] | null
  /**
   * 後端展開特權後的權限清單（見 AdminRepository::permissions()）。
   * 一般帳號等於自身 roles；super admin / maintainer 會展開成系統所有可授予角色。
   * 前端一律用這個欄位判斷權限，不要自行複製「特權自動全過」的規則。
   */
  permissions: string[]
}

/** 登入參數。 */
export interface LoginPayloadInterface {
  email: string
  password: string
  keepLogin: boolean
}

/** token TTL（秒）：對齊後端 TTL_ADMIN / TTL_ADMIN_KEEP_LOGIN。 */
export const TOKEN_MAX_AGE = {
  default: 60 * 60, // 1 小時
  keepLogin: 60 * 60 * 24 * 180, // 半年
} as const

export const TOKEN_COOKIE = 'admin_token'
export const FINGERPRINT_COOKIE = 'admin_fingerprint'

/**
 * 檢查 `?redirect=` 帶進來的值是否為安全的站內相對路徑。
 * 只接受單一開頭 `/`（排除 `//` 或 `/\`），避免有人構造 `/login?redirect=//evil.com`
 * 這種 protocol-relative URL 觸發 open redirect。
 */
export function isSafeRedirectPath(path: unknown): path is string {
  return typeof path === 'string' && /^\/(?!\/|\\)/.test(path)
}

/**
 * 把後端登入失敗 reason 轉成繁中訊息。
 * reason 來自 Modules\Base\Constants\LoginConstants。
 */
export function loginFailMessage(reason?: string): string {
  // reason 值對齊後端 LoginConstants（小寫）：
  // wrong_email_or_password / locked / too_frequent
  switch (reason) {
    case 'wrong_email_or_password':
      return '帳號或密碼錯誤'
    case 'locked':
      return '帳號已被鎖定，請聯絡管理員'
    case 'too_frequent':
      return '嘗試過於頻繁，請稍後再試'
    default:
      return '登入失敗，請稍後再試'
  }
}
